export interface IUnitType {
  average: string;
  distance: string;
  volume: string;
  currency: string;
  mileage: string;
}

export enum Average {
  MILES_PER_GALON = 'mpg',
  KILOMETRES_PER_LITRE = 'kpl'
}

export enum Distance {
  MILE = 'mi',
  KILOMETRE = 'km'
}

export enum Volume {
  GALLON = 'gal',
  LITRE = 'ltr'
}

export enum Currency {
  USD = 'USD',
  CAD = 'CAD'
}

export enum Mileage {
  MILEAGE = 'Mileage',
  KILOMETER = 'Kilometer'
}
